import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', to: '/' },
  { label: 'À propos', to: '/a-propos' },
  { label: 'Contact', to: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        transparent
          ? 'bg-transparent'
          : 'bg-white border-b border-neutral-100'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16 lg:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/919c54e0-bd86-457d-a962-43ad1a5aaa7f.png"
            alt="HASPICA Studio de Design"
            className="h-8 w-auto object-contain"
          />
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                transparent
                  ? 'text-white/90 hover:text-white'
                  : location.pathname === link.to
                  ? 'text-neutral-900'
                  : 'text-neutral-500 hover:text-neutral-900'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className={`text-sm font-medium px-5 py-2 rounded-sm border transition-all duration-200 whitespace-nowrap cursor-pointer ${
              transparent
                ? 'border-white/80 text-white hover:bg-white hover:text-neutral-900'
                : 'border-neutral-900 text-neutral-900 hover:bg-neutral-900 hover:text-white'
            }`}
          >
            Nous contacter
          </Link>
        </div>

        {/* Mobile burger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors ${
            transparent ? 'text-white' : 'text-neutral-900'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-white border-t border-neutral-100 ${
          menuOpen ? 'max-h-72 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm font-medium text-neutral-700 hover:text-neutral-900 transition-colors py-1 cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="text-sm font-medium text-neutral-900 border border-neutral-900 px-5 py-2 rounded-sm text-center hover:bg-neutral-900 hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            Nous contacter
          </Link>
        </div>
      </div>
    </nav>
  );
}
